<template>
  <div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Invitation Details</p>
      </header>
      <section class="modal-card-body">
        <div>
          <table class="table is-fullwidth is-striped is-size-7 is-narrow border">
            <thead>
              <tr>
                <th>Email</th>
                <th>Event</th>
                <th>Created At</th>
                <th>Updated At</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="e in invitation.sendgrid_events" :key="e.id">
                <td>{{ e.email }}</td>
                <td>
                  <span>{{ $utils.capitalize(e.event_type) }}</span>
                </td>
                <td>{{ $dates.utc(e.created_at).local().format('MMM D') }}</td>
                <td>{{ $dates.utc(e.updated_at).local().format('MMM D') }}</td>
              </tr>

              <tr v-if="!invitation.sendgrid_events.length">
                <td colspan="8" class="has-text-centered has-text-grey">No events</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <b-button @click="$parent.close()">Close</b-button>
        <b-button type="is-primary" @click="resend" :loading="loading" :disabled="loading">Resend</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/connection-invites/' + this.invitation.id + '/resend/'
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    resend () {
      this.loading = true
      this.$http.post(this.endpoint).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Resent invitation.' })
      }).finally(() => {
        this.loading = false
        this.$parent.close()
      })
    }
  },
  props: {
    invitation: {
      type: Object
    }
  }
}
</script>
